export default __webpack_public_path__ + "static/media/cloche.98a44b82.mp3";